function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.3398 30.73C84.3398 33.53 82.9398 34.9301 80.1398 34.9301H73.8398C71.0398 34.9301 69.6398 33.53 69.6398 30.73V13.9301H63.3398V30.73C63.3398 37.73 66.8398 41.23 73.8398 41.23H80.1398C87.1398 41.23 90.6398 37.73 90.6398 30.73V13.9301H84.3398V30.73Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M119.14 27.58C119.98 26.25 120.4 24.5 120.4 22.33C120.4 16.73 117.6 13.9301 112 13.9301H93.0996V20.23H112C113.4 20.23 114.1 20.93 114.1 22.33C114.1 23.73 113.4 24.4301 112 24.4301H93.0996V41.23H112C117.6 41.23 120.4 38.43 120.4 32.83C120.4 30.66 119.98 28.91 119.14 27.58ZM111.99 34.9301H99.3896V30.73H111.99C113.39 30.73 114.09 31.43 114.09 32.83C114.09 34.23 113.39 34.9301 111.99 34.9301Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M181.31 41.23H208.62V34.9301H187.61V30.73H208.62V24.4301H181.31V41.23Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M183.53 13.92H160.31C154.71 13.92 151.91 16.72 151.91 22.32C151.91 27.92 154.71 30.72 160.31 30.72H170.81C172.21 30.72 172.91 31.42 172.91 32.82C172.91 34.22 172.21 34.92 170.81 34.92H149.28L136.15 12.17L119.39 41.22H126.66L136.15 24.77L145.64 41.22H170.8C176.4 41.22 179.2 38.42 179.2 32.82C179.2 27.22 176.4 24.42 170.8 24.42H160.3C158.9 24.42 158.2 23.72 158.2 22.32C158.2 20.92 158.9 20.22 160.3 20.22H208.61V13.92H183.52H183.53Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.35 0L0 15.21V38.21L26.35 53.42L52.7 38.21V15.21L26.35 0ZM48.33 35.68L26.35 48.37L4.37 35.68V17.73L26.35 5.03999L48.33 17.73V35.68Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3 14.9V19.05L10.31 21.36V25.52L6.45996 27.74V34.42L26.35 45.91L46.24 34.42V19.26L26.33 7.77002L14.3 14.89V14.9ZM26.35 40.87L10.82 31.91V30.27L12.49 29.31L29.44 39.1L26.35 40.89V40.87ZM30.2 34.48L14.67 25.52V23.88L16.48 22.83L33.43 32.62L30.2 34.49V34.48ZM41.87 21.79V23.45L34.17 28L18.66 19.04V17.38L26.35 12.83L41.86 21.79H41.87Z",
  fill: "white"
});

function SvgWhitelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 54,
    viewBox: "0 0 209 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelogo);
export default __webpack_public_path__ + "static/media/whitelogo.1a2498c5.svg";
export { ForwardRef as ReactComponent };